const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4176 4.66602L12.4438 17.9993H11.7777L12.1863 14.6997C9.19735 15.2376 7.82635 15.3708 8.07346 15.0996C8.32057 14.8282 8.51535 14.4438 8.65768 13.9461L4.66602 11.283C5.08578 11.2778 5.4664 11.1736 5.8079 10.9705C6.14935 10.7673 5.97868 10.0636 5.29566 8.85901L7.31101 9.15224L8.07346 8.32357L9.59401 9.91502H10.2775L9.59401 6.26983L10.8191 6.95415L12.4176 4.66602ZM12.4176 4.66602L14.0685 6.95415L15.2936 6.26983L14.6101 9.91502H15.2936L16.8141 8.32357L17.5766 9.15224L19.5919 8.85901C18.9089 10.0636 18.7382 10.7673 19.0797 10.9705C19.4211 11.1736 19.8018 11.2778 20.2216 11.283L16.2299 13.9461C16.3722 14.4438 16.567 14.8282 16.8141 15.0996C17.0612 15.3708 15.6902 15.2376 12.7012 14.6997L13.1099 17.9993H12.4438L12.4176 4.66602Z",
    fill: "#E31D1C",
    style: {
      fill: "#E31D1C",
      fill: "color(display-p3 0.8902 0.1137 0.1098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.332 -3.11133H30.2209V23.5553H21.332V-3.11133Z",
    fill: "#E31D1C",
    style: {
      fill: "#E31D1C",
      fill: "color(display-p3 0.8902 0.1137 0.1098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.33398 -3.11133H3.5549V23.5553H-5.33398V-3.11133Z",
    fill: "#E31D1C",
    style: {
      fill: "#E31D1C",
      fill: "color(display-p3 0.8902 0.1137 0.1098)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.9a9d2f49b31380c02af28d017ad5e8cf.svg";
export { ForwardRef as ReactComponent };